import {ActivatedRoute, Router} from '@angular/router';
import {Crud} from '../services/crud';
import {Injectable, OnInit} from '@angular/core';

@Injectable()
export abstract class CrudDetails implements OnInit {

  entity: any = {};
  entityid = '';

  redirecturl = '';

  constructor(
    protected httpcrud: Crud,
    protected route: ActivatedRoute,
    protected router: Router,
  ) {
  }

  ngOnInit(): void {
    this.initSpecificDetailsConfig();
    this.initDetails();
  }

  protected abstract initSpecificDetailsConfig(): void;

  private initDetails() {
    this.entityid = this.route.snapshot.paramMap.get('id');

    if (this.entityid) {
      // Edit
      const query = this.httpcrud.getEntity(this.entityid);
      query.subscribe((allresults) => {
        this.entity = allresults.results;
      });
    }
  }

  public back() {
    this.router.navigate([this.redirecturl]);
  }

}
